import checked from '../assets/checked.png';
import unchecked from '../assets/unchecked.png';
import { PartnerDetail } from '../types/types';

interface Props {
  partner: PartnerDetail;
  isPartnerSelected: boolean;
  handlePartnerClick: (partner: PartnerDetail) => void;
  index: number;
}

const PartnerItem: React.FC<Props> = ({ partner, isPartnerSelected, handlePartnerClick, index }) => {
  return (
    <div className="filter-list__checkbox-item__box pt-2 pb-2" onClick={() => handlePartnerClick(partner)}>
      <img width={20} height={20} alt="checkmark" src={isPartnerSelected ? checked : unchecked} />
      <div className="filter-list__checkbox-item__name d-inline-block">
        <span data-partners-key={index} data-partner-id={partner.id}>
          {partner.name}
        </span>
        <span> ({partner.adCount})</span>
      </div>
    </div>
  );
};

export default PartnerItem;
